<template>
  <NoteSection
    label="Risk Factors"
    required
    :highlight-required="isSectionIncomplete"
    :form-validated="formValidated"
  >
    <!-- Old display method, changed to multi-select list box for higher user input speed
    <select-box
      v-for="(item, i) in risk_factors"
      :key="`item-${i}-${risk_factors.length}`"
      v-model="risk_factors[i]"
      :items="riskFactors"
      :append-icon="icons.mdiCloseThick"
      label="Select from list"
      class="col-sm-4 risk-factors"
      clearable="false"
      hide-details
      return-object
      @click:append="risk_factors.splice(i, 1)"
    ></select-box>
    <div class="col-sm-4">
      <btn
        label="Add Risk Factor"
        class="risk-factors"
        :icon="icons.mdiTablePlus"
        :disabled="isSigned"
        @click="risk_factors.push({id:null})"
      ></btn>
    </div>
    -->
    <auto-complete-box
      v-if="risk_factors"
      v-model="risk_factors"
      :items="riskFactors"
      label="Choose risk factors"
      class="col-sm-12"
      multiple
      return-object
      :required="isRiskFactorsRequired"
    ></auto-complete-box>
    <text-area
      v-model="risk_factors_other"
      label="Enter other risk factors..."
      class="col-sm-12"
      counter="1200"
      maxlength="1200"
    ></text-area>
  </NoteSection>
</template>

<script>
import { mdiCloseThick, mdiTablePlus } from '@mdi/js';
import { mapGetters } from 'vuex';

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    riskFactorsOther: {
      type: String,
      default: null,
    },
    isSigned: {
      type: Boolean,
      default: false,
    },
    formValidated: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      risk_factors: [...(this.value || [])],
      risk_factors_other: this.riskFactorsOther,
      icons: { mdiTablePlus, mdiCloseThick },
    }
  },
  computed: {
    ...mapGetters('encounters', ['riskFactors']),

    isRiskFactorsRequired() {
      // Ensure risk_factors_other is a string and trim whitespace
      const trimmedValue = typeof this.risk_factors_other === 'string'
        ? this.risk_factors_other.trim()
        : ''
      // Return true if the trimmed value is empty, indicating that the field is required
      return !trimmedValue
    },
    // Evaluates if the section is missing required data
    isSectionIncomplete() {
      const hasSelectedFactors = this.risk_factors && this.risk_factors.length > 0
      const hasOtherFactor = typeof this.risk_factors_other === 'string' && this.risk_factors_other.trim().length > 0

      return !hasSelectedFactors && !hasOtherFactor
    },
  },
  watch: {
    risk_factors() {
      this.$emit('input', this.risk_factors)
    },
    risk_factors_other() {
      this.$emit('update:risk-factors-other', this.risk_factors_other)
    },
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
.risk-factors {
  margin-bottom: 15px !important;
  &.v-btn {
    width: 100%;
    margin-bottom: 19px !important;
  }
}
</style>
